export default function CaseStudies() {
  return (
    <section id="cases" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-teal-50 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-bar-chart-line"></i>
            Измеримые результаты
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Кейсы
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Примеры из практики. Компании из разных отраслей, которые уже получили результат.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8">
          <div className="bg-gray-50 rounded-2xl p-6 md:p-8 border border-gray-100">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-14 h-14 overflow-hidden rounded-xl bg-teal-100 flex items-center justify-center flex-shrink-0">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20international%20logistics%20company%20office%20interior%20with%20world%20map%20on%20wall%20team%20working%20at%20desks%20professional%20atmosphere%20clean%20bright%20space%20with%20natural%20light%20warm%20tones%20corporate%20design&width=200&height=200&seq=b2b-logistics-case&orientation=squarish"
                  alt="Международная логистическая компания"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <div className="text-xs font-semibold text-teal-600 tracking-wider mb-1">КЕЙС 1</div>
                <h3 className="text-lg font-bold text-gray-900">Международная логистическая компания</h3>
              </div>
            </div>
            <p className="text-sm text-gray-600 leading-relaxed mb-5">
              Менеджеры продавали логистические услуги как commodity, не выделяя ценность. После диагностики, обучения работе с ЛПР и сопровождения отдела продаж.
            </p>
            <div className="flex flex-wrap gap-2 mb-5">
              {['Диагностика', 'Тренинг', 'Сопровождение', 'Разбор сделок'].map((tag, i) => (
                <span key={i} className="bg-teal-50 text-teal-700 text-xs px-3 py-1.5 rounded-full font-medium border border-teal-100">{tag}</span>
              ))}
            </div>
            <div className="bg-teal-600/10 rounded-xl p-4 text-center">
              <div className="text-3xl font-extrabold text-teal-600 mb-1">18–23%</div>
              <div className="text-sm text-gray-600">рост конверсии после сопровождения отдела продаж</div>
            </div>
          </div>

          <div className="bg-gray-50 rounded-2xl p-6 md:p-8 border border-gray-100">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-14 h-14 overflow-hidden rounded-xl bg-teal-100 flex items-center justify-center flex-shrink-0">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20luxury%20concierge%20service%20office%20interior%20with%20professional%20assistants%20at%20work%20elegant%20atmosphere%20warm%20lighting%20clean%20design%20high-end%20corporate%20environment&width=200&height=200&seq=b2b-concierge-case&orientation=squarish"
                  alt="Консьерж сервис"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <div className="text-xs font-semibold text-teal-600 tracking-wider mb-1">КЕЙС 2</div>
                <h3 className="text-lg font-bold text-gray-900">Консьерж сервис</h3>
              </div>
            </div>
            <p className="text-sm text-gray-600 leading-relaxed mb-5">
              Рост продлений и среднего чека благодаря обучению переговорам, работе с ценностью и умению аргументировать стоимость услуги перед требовательными клиентами.
            </p>
            <div className="flex flex-wrap gap-2 mb-5">
              {['Тренинг', 'Переговоры', 'Работа с ценностью', 'Сопровождение'].map((tag, i) => (
                <span key={i} className="bg-teal-50 text-teal-700 text-xs px-3 py-1.5 rounded-full font-medium border border-teal-100">{tag}</span>
              ))}
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div className="bg-teal-600/10 rounded-xl p-3 text-center">
                <div className="text-2xl font-extrabold text-teal-600 mb-0.5">64→84%</div>
                <div className="text-xs text-gray-600">рост продлений</div>
              </div>
              <div className="bg-teal-600/10 rounded-xl p-3 text-center">
                <div className="text-2xl font-extrabold text-teal-600 mb-0.5">×9</div>
                <div className="text-xs text-gray-600">рост длительных оплат</div>
              </div>
            </div>
          </div>

          <div className="bg-gray-50 rounded-2xl p-6 md:p-8 border border-gray-100">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-14 h-14 overflow-hidden rounded-xl bg-teal-100 flex items-center justify-center flex-shrink-0">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20industrial%20import%20distribution%20warehouse%20interior%20with%20professional%20team%20managing%20logistics%20operations%20clean%20organized%20space%20with%20shelving%20units%20warm%20natural%20lighting%20professional%20atmosphere&width=200&height=200&seq=b2b-import-case&orientation=squarish"
                  alt="Импортёр"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <div className="text-xs font-semibold text-teal-600 tracking-wider mb-1">КЕЙС 3</div>
                <h3 className="text-lg font-bold text-gray-900">Импортёр</h3>
              </div>
            </div>
            <p className="text-sm text-gray-600 leading-relaxed mb-5">
              После проведения аудита отдела продаж и внедрения рекомендаций: изменение подхода к переговорам, работа с ЛПР, систематизация follow-up.
            </p>
            <div className="flex flex-wrap gap-2 mb-5">
              {['Аудит', 'Рекомендации', 'Внедрение', 'Сопровождение'].map((tag, i) => (
                <span key={i} className="bg-teal-50 text-teal-700 text-xs px-3 py-1.5 rounded-full font-medium border border-teal-100">{tag}</span>
              ))}
            </div>
            <div className="bg-teal-600/10 rounded-xl p-4 text-center">
              <div className="text-3xl font-extrabold text-teal-600 mb-1">+30%</div>
              <div className="text-sm text-gray-600">рост продаж после внедрения рекомендаций</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}